import React, { createContext, useContext, useState, ReactNode } from "react";
import { Bet } from "../../types/Bet";

interface BetContextProps {
  bets: Bet[];
  setBets: React.Dispatch<React.SetStateAction<Bet[]>>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const BetContext = createContext<BetContextProps | undefined>(undefined);

export const BetProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [bets, setBets] = useState<Bet[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <BetContext.Provider value={{ bets, setBets, isLoading, setIsLoading }}>
      {children}
    </BetContext.Provider>
  );
};

export const useBets = (): BetContextProps => {
  const context = useContext(BetContext);
  if (!context) {
    throw new Error("useBets must be used within a BetProvider");
  }
  return context;
};
